/**
 * ISO 3166-1 alpha-3 codes for EU member states
 * Updated as of 2024 (27 member states post-Brexit)
 */
export const EU_COUNTRY_CODES: { [key: string]: boolean } = {
  AUT: true, // Austria
  BEL: true, // Belgium
  BGR: true, // Bulgaria
  HRV: true, // Croatia
  CYP: true, // Cyprus
  CZE: true, // Czech Republic
  DNK: true, // Denmark
  EST: true, // Estonia
  FIN: true, // Finland
  FRA: true, // France
  DEU: true, // Germany
  GRC: true, // Greece
  HUN: true, // Hungary
  IRL: true, // Ireland
  ITA: true, // Italy
  LVA: true, // Latvia
  LTU: true, // Lithuania
  LUX: true, // Luxembourg
  MLT: true, // Malta
  NLD: true, // Netherlands
  POL: true, // Poland
  PRT: true, // Portugal
  ROU: true, // Romania
  SVK: true, // Slovakia
  SVN: true, // Slovenia
  ESP: true, // Spain
  SWE: true, // Sweden
};
